import { render, staticRenderFns } from "./LableImage.vue?vue&type=template&id=7b6ac88a&scoped=true&"
import script from "./LableImage.vue?vue&type=script&lang=js&"
export * from "./LableImage.vue?vue&type=script&lang=js&"
import style0 from "./LableImage.vue?vue&type=style&index=0&id=7b6ac88a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ac88a",
  null
  
)

export default component.exports